var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogob2B(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 227.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #ea0029;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #fde021;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 141.73,
    cy: 123.59,
    rx: 141.73,
    ry: 103.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 141.73,
    cy: 123.59,
    rx: 141.73,
    ry: 103.84
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72,146.1h-16.14v-56.32c-.09-2.2-.98-2.41-2.41-2.41h-13.96c-.98,0-2.22,0-2.31,2.51v68.68c.09,2.3,.71,2.72,2.4,2.72h32.42c1.25,0,2.32-.21,2.32-2.51v-10.37c0-2.3-1.07-2.3-2.32-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.7,89.17v68.88c0,3.23-1.6,3.23-2.49,3.23h-14.06c-1.42,0-2.49-.46-2.49-3.34V89.22c3.03,.6,6.16,.91,9.36,.91s6.54-.33,9.67-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.29,87.37h-9.43c-1.87,0-2.41,.42-2.94,2.51l-8.45,35.28-6.94-34.86c-.53-2.51-1.06-2.93-3.2-2.93h-14.59c-.71,0-2.14-.1-2.14,1.57,0,.41,.09,.83,.36,1.99l17.97,67.95c.62,2.2,1.06,2.41,2.93,2.41h7.39c2.14,0,2.4-.63,3.11-3.14l17.88-66.58c.27-1.15,.44-1.68,.44-2.2,0-1.68-1.24-2.09-2.4-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M118.77,87.37h-33.27c-2.14,0-2.84,.83-2.93,3.24v67.52c0,2.41,.71,3.14,2.84,3.14h33.44c1.96,0,2.58-.63,2.58-2.83v-9.42c0-2.52-.98-2.94-2.58-2.94h-17.61v-15.38h14.76c1.78,0,2.76-.32,2.76-2.83v-8.9c0-2.51-1.25-2.72-2.94-2.72h-14.58v-14.13h17.52c1.69,0,2.67-.32,2.67-2.83v-9.32c.09-2.51-1.06-2.61-2.67-2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.67,157.72l-18.94-67.63c-.63-1.99-.98-2.72-3.11-2.72h-8.72c-1.87,0-2.4,.63-3.11,2.72l-18.95,66.58c-.09,.21-.71,2.41-.71,2.72,0,1.46,.98,1.88,2.13,1.88h9.34c2.05,0,2.49-.73,2.94-2.72l1.78-8.37h15.92l1.87,8.58c.44,1.88,.98,2.51,2.85,2.51h14.49c.98,0,2.49-.1,2.49-2.1,0-.52-.17-1.05-.27-1.46Zm-34.33-19.16l4.8-22.3,5.07,22.3h-9.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.73,0c-20.46,0-37.1,16.64-37.1,37.1s16.64,37.1,37.1,37.1,37.1-16.64,37.1-37.1S162.19,0,141.73,0h0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogob2B);
export default __webpack_public_path__ + "static/media/logob2b.ac25475a634e11041d4d58001136022f.svg";
export { ForwardRef as ReactComponent };